import type { ReactNode } from 'react';
import { IfWrites } from '../write-access';
import { REFRESH_ACTION } from '../../lib/copy';
import '../record/record-body.css';

export function ResearchFooter({
  stamp,
  onRuns,
  onHistory,
  onRefresh,
  rawData,
  deleteAction,
}: {
  stamp?: ReactNode;
  /** Absent on a record with no run history to open (an organization). */
  onRuns?: () => void;
  onHistory?: () => void;
  onRefresh?: () => void;
  rawData: ReactNode;
  deleteAction?: ReactNode;
}) {
  /* One row: the stamp, the record's quiet doors, and the destructive action
     last, set off by a hairline. The weight is in the confirmation it opens. */
  return (
    <footer className="rec-foot">
      <span className="stamp">{stamp}</span>
      <nav aria-label="Record">
        {onRuns && (
          <button type="button" className="foot-link" onClick={onRuns}>
            Runs
          </button>
        )}
        {onHistory && (
          <button type="button" className="foot-link" onClick={onHistory}>
            Decision log
          </button>
        )}
        {onRefresh && (
          <IfWrites>
            <button type="button" className="foot-link" onClick={onRefresh}>
              {REFRESH_ACTION}
            </button>
          </IfWrites>
        )}
        {rawData}
      </nav>
      {deleteAction && <IfWrites>{deleteAction}</IfWrites>}
    </footer>
  );
}
